import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';
import {
  createNewSurveyAnswer,
  deleteSurveyAnswer,
} from 'redux/slices/legacySurveySlice';
import { useAppDispatch } from 'redux/store-hooks';
import type { SurveyProps } from './types';

const SurveySelect = ({
  question,
  register,
  unregister,
  setValue,
  response,
  getValues,
}: SurveyProps) => {
  const [selectValue, setSelectValue] = useState([]);
  const dispatch = useAppDispatch();

  const handleChange = event => {
    if (!event.target.value) {
      setSelectValue([]);
      setValue(question.id, []);
      dispatch(
        deleteSurveyAnswer({
          params: {
            questionId: question.id,
            responseId: response.id,
          },
        })
      );
    } else {
      setSelectValue(event.target.value);
      setValue(question.id, event.target.value);
      dispatch(
        createNewSurveyAnswer({
          body: {
            questionId: question.id,
            responseId: response.id,
            optionId: event.target.value,
          },
        })
      );
    }
  };

  const registerProps = register(question.id, {
    required: question.isRequired,
    onChange: handleChange,
  });

  useEffect(() => {
    const initialValue = getValues(question.id);

    if (initialValue) {
      setSelectValue(initialValue);
    }

    return () => {
      unregister(question.id);
    };
  }, []);

  const emptyValue = () => {
    if (question.allowMultiple) {
      return [];
    } else {
      return '';
    }
  };

  let label = question.input.title;
  if (question.isRequired) label += '*';

  return (
    <FormControl
      fullWidth
      sx={{
        marginTop: '12px',
      }}
    >
      <InputLabel id={`ql-${question.id}`}>{label}</InputLabel>
      <Select
        {...registerProps}
        labelId={`ql-${question.id}`}
        id="survey-select"
        label={label}
        multiple={question.allowMultiple}
        value={selectValue.length ? selectValue : emptyValue()}
      >
        {question.options.map(option => {
          return (
            <MenuItem key={option.id} value={option.id}>
              {option.text}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SurveySelect;
